import Share from 'react-native-share'
import axios from 'axios'
import { dataTypes } from '@adalo/constants'

// eslint-disable-next-line global-require
global.Buffer = global.Buffer || require('buffer').Buffer

const MIME_TYPES = {
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  pdf: 'application/pdf',
}

export const share = async (source, bindingData, helpers) => {
  if (!source) {
    return
  }

  const shareOpts = {
    title: (bindingData && bindingData.filename) || bindingData,
    failOnCancel: false,
  }

  if (
    source.dataType === dataTypes.IMAGE ||
    source.dataType === dataTypes.FILE
  ) {
    let path = bindingData

    if (bindingData) {
      path = bindingData.url
    }

    const pathPieces = path.split('.')
    const extension = pathPieces[pathPieces.length - 1]
    const mimeType = MIME_TYPES[extension]

    const baseURL =
      source.dataType === dataTypes.IMAGE
        ? helpers.getImageUploadsBaseURL()
        : helpers.getFileUploadsBaseURL()

    const url = `${baseURL}/${path}?orient`
    try {
      shareOpts.url = `data:${mimeType};base64,${await getBase64(url)}`
      shareOpts.filename = shareOpts.title
      shareOpts.message = shareOpts.title
      shareOpts.type = mimeType
      shareOpts.extension = extension
    } catch (e) {
      shareOpts.url = url
    }
  } else {
    shareOpts.message = bindingData ? String(bindingData) : ''
  }

  await Share.open(shareOpts)
}

function getBase64(url) {
  return axios
    .get(url, {
      responseType: 'arraybuffer',
    })
    .then(response => Buffer.from(response.data, 'binary').toString('base64'))
}
